import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from "@air/primitive-label";
import { tailwindMerge } from "@air/tailwind-variants";
import { useField } from "formik";
import capitalize from "lodash/capitalize";
import { useCallback, useMemo } from "react";
import { SingleSelect } from "~/components/Select/SingleSelect";
import { CUSTOM_FIELD_TYPE_INPUT } from "~/constants/testIDs";
import { CUSTOM_FIELD_MODAL_FORM_FIELD_TYPE } from "../../CustomFieldModal";
import { CustomFieldTypeLabel } from "./CustomFieldTypeLabel";
import { CustomFieldTypeSelectListItem } from "./CustomFieldTypeSelectListItem";
export const FormikCustomFieldTypeSelect = (param)=>{
    let { canEditFieldType, fieldTypes, className } = param;
    const [fieldTypeProps] = useField(CUSTOM_FIELD_MODAL_FORM_FIELD_TYPE);
    const onSelectionChange = useCallback((param)=>{
        let { chips } = param;
        const value = chips[0].value;
        fieldTypeProps.onChange({
            target: {
                value,
                name: CUSTOM_FIELD_MODAL_FORM_FIELD_TYPE
            }
        });
    }, [
        fieldTypeProps
    ]);
    const selectedOptions = useMemo(()=>{
        const fieldType = fieldTypes.find((ft)=>ft.id === fieldTypeProps.value);
        if (!fieldType) return undefined;
        return {
            value: fieldType.id,
            label: capitalize(fieldType.title)
        };
    }, [
        fieldTypeProps.value,
        fieldTypes
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex flex-col gap-1", className),
        children: [
            /*#__PURE__*/ _jsx(Label, {
                children: "Field type"
            }),
            /*#__PURE__*/ _jsx(SingleSelect, {
                "data-testid": CUSTOM_FIELD_TYPE_INPUT,
                chipRenderer: (chip)=>/*#__PURE__*/ _jsx(CustomFieldTypeLabel, {
                        fieldTypeId: chip.value,
                        fieldTypes: fieldTypes
                    }),
                onSelectionChange: onSelectionChange,
                renderAsInput: canEditFieldType,
                disabled: !canEditFieldType,
                size: "large",
                closeMenuOnSelect: true,
                listItemRenderer: (chip)=>/*#__PURE__*/ _jsx(CustomFieldTypeSelectListItem, {
                        fieldTypeId: chip.value,
                        fieldTypes: fieldTypes
                    }),
                filterFunc: (options)=>options,
                selectedOption: selectedOptions,
                options: fieldTypes.map((ft)=>({
                        value: ft.id,
                        label: capitalize(ft.title)
                    }))
            })
        ]
    });
};
